var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarProfileManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73145 4.57153V1.71439C2.73145 1.41129 2.85185 1.1206 3.06618 0.906268C3.28051 0.691941 3.5712 0.571533 3.8743 0.571533H9.58859L15.3029 6.28582V14.2858C15.3029 14.5889 15.1825 14.8796 14.9681 15.0939C14.7538 15.3083 14.4631 15.4287 14.16 15.4287H10.16",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58856 0.571533V6.28582H15.3028M4.15997 7.42871V9.143M0.697144 9.42871L2.18286 10.2859M0.697144 13.4287L2.18286 12.5715M4.15997 15.4286V13.7144M7.62286 13.4287L6.13715 12.5715M7.62286 9.42871L6.13715 10.2859",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15998 13.7145C5.42235 13.7145 6.4457 12.6911 6.4457 11.4288C6.4457 10.1664 5.42235 9.14307 4.15998 9.14307C2.89762 9.14307 1.87427 10.1664 1.87427 11.4288C1.87427 12.6911 2.89762 13.7145 4.15998 13.7145Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarProfileManagement);
export default __webpack_public_path__ + "static/media/sidebar-profile-management.596d2c3b78583974de61e308e58291a0.svg";
export { ForwardRef as ReactComponent };